import { render, staticRenderFns } from "./OperaInternalCompanyWindow.vue?vue&type=template&id=68068fd2&"
import script from "./OperaInternalCompanyWindow.vue?vue&type=script&lang=js&"
export * from "./OperaInternalCompanyWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports